// removed by extract-text-webpack-plugin
module.exports = {"loadingWrapper":"_1jzje","loader":"_3EltM"};


//////////////////
// WEBPACK FOOTER
// ./containers/stages/SubmitStage/styles.scss
// module id = 742
// module chunks = 0